import { Typography } from '@mui/material';
import { Box, styled } from '@mui/system';

export const RootDiv = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '8px',
  backgroundColor: '#E6F3FA',
  color: '#003654',
});

export const ImgDiv = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  width: '24px',
  height: '24px',
});

export const TextDiv = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const Title = styled(Typography)({
  fontWeight: '600',
  fontSize: '12px',
  lineHeight: '15.6px',
  letterSpacing: '0.15px',
});

export const InformationText = styled(Typography)({
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.15px',
  '& span': {
    fontWeight: '600',
  },
});
